import { routeFactory } from "@/RouteFactory";
import { Crumb } from "@/components/bread-crumbs/Crumb";
import { PageHeader } from "@/components/page-header/PageHeader";
import { BreadCrumbs } from "@stenajs-webui/elements";
import * as React from "react";

interface Props {
  customerId: string;
  breadCrumbName: string;
}

export const CustomerPriceParentHeader: React.FC<Props> = ({
  customerId,
  breadCrumbName,
}) => (
  <PageHeader
    title={"Customer price parent"}
    breadcrumbs={
      <BreadCrumbs>
        <Crumb
          label={breadCrumbName}
          path={routeFactory.productAndPrice.customer.customer({
            customerId,
          })}
        />
        <Crumb label={"Price parent"} />
      </BreadCrumbs>
    }
  />
);
